import React from 'react'

import { StyledButton } from './ButtonStyledComponents'

const Button = ({ variant = 'primary', type = 'button', children, ...prop }) => (
  <StyledButton $variant={variant} type={type} {...prop}>
    {children}
  </StyledButton>
)

Button.displayName = 'Button'

export default Button
